export default "__VITE_ASSET__3a0fa825__"